"use strict";

$(function () {
    // Affiche l'input pour modifier la référence entreprise du BC
    $(".ref-edit-btn").click(function () {
        var $this = $(this).first();
        // On cache la réf
        $this.parents(".ref-entr").addClass("d-none");
        // Et on affiche l'input pour le modifier
        var form = $this.parents(".box-bc-ref").find(".ref-entr-form");
        $(form).removeClass("d-none");
    });
    // Affiche l'input pour modifier la référence entreprise du BC
    $(".ref-add-btn").click(function () {
        var $this = $(this).first();
        // On cache le bouton
        $this.addClass("d-none");
        // Et on affiche l'input
        var form = $this.parents(".box-bc-ref").find(".ref-entr-form");
        form.removeClass("d-none");
    });
});


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Affaire/bon-commandes.ts
// module id = 600
// module chunks = 0